import { Link } from 'react-router-dom';
import { PATHS } from '../../../../constants/routes';
import SectionBody from '../../../layouts/showcaseLayouts/Section/SectionBody/SectionBody';
import Placeholder from '../../../UI/Placeholder/Placeholder';
import classes from './NotFound.module.css';

const NotFound: React.FC = () => {
    return (
        <SectionBody>
            <div className={classes['not-found']}>
                <Placeholder text={'такой страницы нет'} />
                <span className={classes.title}>404</span>

                <div className={classes['wrapper']}>
                    <span className={classes.subTitle}>Перейти:</span>
                    <div className={classes['link-wrapper']}>
                        <Link to={PATHS.main} className={classes.link}>
                            На главную
                        </Link>
                        <Link to={`${PATHS.showcase}`} className={classes.link}>
                            В каталог
                        </Link>
                        {/* <Link to={`${PATHS.admin}${PATHS.orders}`} className={classes.link}>
              В админку
            </Link> */}
                    </div>
                </div>
            </div>
        </SectionBody>
    );
};

export default NotFound;
